import { createContext, useContext } from 'react';

export const EscalationHistoryPanelContext = createContext(null);

export function useEscalationHistoryPanel() {
  const ctx = useContext(EscalationHistoryPanelContext);
  if (!ctx) {
    throw new Error('useEscalationHistoryPanel must be used within EscalationHistoryProvider');
  }
  return ctx;
}

export function useEscalationHistoryPanelOptional() {
  return useContext(EscalationHistoryPanelContext);
}
